import { Checkbox, FormControlLabel } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTheme } from "styled-components";

function CustomCheckBox() {
  const defaultStyledTheme = useTheme();
  const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
    color: defaultStyledTheme.text, // Default square border color
    "&.Mui-checked": {
      color: defaultStyledTheme.circularIconBg, // Square and tick color when checked
    },
    "&.MuiCheckbox-root:hover": {
      backgroundColor: defaultStyledTheme.checkBoxLightHover, // Light hover background
    },
    "& .MuiSvgIcon-root": {
      fontSize: "1.6rem", // Adjust size if needed
    },
  }));

  return (
    <FormControlLabel
      control={
        <CustomCheckbox
          id="isOngoingCheckbox"
          name="isOngoing"
          checked={false}
          // onChange={handleCheckboxChange}
        />
      }
      label="Ongoing project"
    />
  );
}

export default CustomCheckBox;